import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getJournalEquipmentAvailableColumns } from './api';

export const path = '/ppr/journal-equipment/list';

const PageJournalEquipmentList: React.FC = (props) => {
  const JournalEquipments = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getJournalEquipmentAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <JournalEquipments {...props} />;
};

export default PageJournalEquipmentList;
